import { render, staticRenderFns } from "./user-timestamp-logs.vue?vue&type=template&id=61981ac8&scoped=true&"
import script from "./user-timestamp-logs.vue?vue&type=script&lang=js&"
export * from "./user-timestamp-logs.vue?vue&type=script&lang=js&"
import style0 from "./user-timestamp-logs.vue?vue&type=style&index=0&id=61981ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61981ac8",
  null
  
)

export default component.exports